import { CircularProgress } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import { Field, useFormikContext } from 'formik';
import React, { memo } from 'react';
import { useObservable } from 'react-use-observable';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { SelectProduct } from 'v2/components/Shared/FormFields/SelectProduct';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import affiliateService, { InitialFilter } from 'v2/services/affiliate';

import type { IFilter } from 'v2/interfaces/affiliate';

import styles from '../styles';
const Basic = () => {
  const classes = styles({});

  const [isLoading] = useObservable(() => affiliateService.isLoading(), []);

  const { values, setFieldValue, isSubmitting, isValid, setErrors, dirty, resetForm } = useFormikContext<IFilter>();

  const onChangeAffiliateType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue('affiliate_type', e.target.value);
    setFieldValue('affiliate_value', '');
    setErrors({});
  };

  const AffiliatesTypeOptions = [
    {
      label: 'Nome',
      value: 'affiliate_name',
    },
    {
      label: 'E-mail',
      value: 'affiliate_email',
    },
  ];

  const StatusOptions = [
    {
      label: 'Pendente',
      value: 'pending',
    },
    {
      label: 'Aprovado',
      value: 'approved',
    },
    {
      label: 'Reprovado',
      value: 'reproved',
    },
  ];

  return (
    <div className={classes.filter}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6} md={4} xl={2}>
          <Field isPresetLonger label='Data da solicitação' id='date' name='date' component={DateRangePickerFormField} />
        </Grid>
        <Grid item xs={12} sm={6} md={4} xl={2}>
          <Field
            id='affiliate_type'
            name='affiliate_type'
            label='Afiliado'
            fullWidth
            options={AffiliatesTypeOptions}
            component={SelectFormField}
            onChange={onChangeAffiliateType}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} xl={2}>
          <Field
            id='affiliate_value'
            name='affiliate_value'
            type={values.affiliate_type === 'affiliate_email' ? 'email' : 'text'}
            label={values.affiliate_type === 'affiliate_email' ? 'E-mail' : 'Nome'}
            placeholder={values.affiliate_type === 'affiliate_email' ? 'Digite o e-mail' : 'Digite o nome'}
            component={TextFormField}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} xl={2}>
          <Field id='product_id' name='product_id' fullWidth label='Produtos' endpoint='/affiliates/filter/products' component={SelectProduct} />
        </Grid>
        <Grid item xs={12} sm={6} md={4} xl={2}>
          <Field id='status' name='status' label='Status' fullWidth options={StatusOptions} component={SelectFormField} />
        </Grid>
        <Grid item xs={12} md={2} xl={1} className={classes.buttonContainer}>
          <Button id='clear-button' disabled={!dirty || isSubmitting || isLoading} fullWidth onClick={() => resetForm({ values: InitialFilter })}>
            <span id='clear-button-label'>Limpar</span>
            {(isLoading || isSubmitting) && <CircularProgress size={10} style={{ color: '#192542', marginLeft: 10 }} />}
          </Button>
        </Grid>
        <Grid item xs={12} md={2} xl={1} className={classes.buttonContainer}>
          <div className={classes.wrapperButtonSubmitFiltes}>
            <Button variant='contained' disabled={!isValid || isSubmitting || isLoading} color='secondary' fullWidth type='submit'>
              <Icon>filter_list</Icon> Filtrar
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default memo(Basic);
